import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import InfoBox from 'components/info-box';
import { ChevronRight, CircleCheck } from 'lucide-react';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useR2ScenarioState } from 'views/bluviu-nutrition/features/scenarios-v2/context/r2-scenario-context';
import { R2ScenarioParams } from 'views/bluviu-nutrition/features/scenarios-v2/types/r2-scenario-params.type';
import { ScenarioSubTab } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-sub-tab.enum';
import { ScenarioState } from 'views/bluviu-nutrition/types/scenario-state.enum';

const R2ScenarioProgress: React.FC<{}> = () => {
  const theme = useTheme();
  const history = useHistory();
  const params = useParams<R2ScenarioParams>();

  const {
    r2ScenarioQuery: { data: scenario },
    r2ScenarioStatusQuery: { data: scenarioStatus },
  } = useR2ScenarioState();

  const handleViewResults = () => {
    history.push(`/bluviu-nutrition/${params.tab}/${params.globalSiteId}/${params.scenarioId}/${ScenarioSubTab.RESULTS}`);
  };

  if (scenario?.state === ScenarioState.SCENARIO_RESULT_SENT) {
    return (
      <>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <CircleCheck size={48} strokeWidth={1.5} color={theme.palette.green.o75} />
          <Typography variant="h6" fontWeight={700}>
            Results are ready!
          </Typography>
          <Button variant="contained" onClick={handleViewResults} endIcon={<ChevronRight />}>
            View results
          </Button>
        </Box>
        <Divider />
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography fontWeight={700}>Review inputs</Typography>
          <Typography variant="body2" color="text.secondary">
            To change inputs in the scenario, clone this scenario or create a new one.
          </Typography>
        </Box>
      </>
    );
  }

  if (scenarioStatus?.scenarioIsRunning) {
    return (
      <InfoBox variant={'light'}>
        <Box display={'flex'} flexDirection={'column'} gap={1}>
          <Typography>Scenario in progress</Typography>
          <Typography>
            You are free to leave this page while the scenario is running. This may take a few minutes depending on the complexity of
            your site data.
          </Typography>
        </Box>
      </InfoBox>
    );
  }

  return (
    <Typography>
      <strong>You're all setup!</strong> Review inputs or run the scenario.
    </Typography>
  );
};

export default React.memo(R2ScenarioProgress);
